import React from "react";
import { decodeToken } from "react-jwt";

// const key_token = "Cookie@_34r523";
const TOKEN_KEY = "client@ecommerce";
const TOKEN_KEY_REFRESH = "clientRefresh@ecommerce";

export const login = (token, refresh_token) => {
  return new Promise((resolve, reject) => {
    try {
      // user the token in localStorage
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(TOKEN_KEY_REFRESH, refresh_token);

      // Resolve the promise successfully
      resolve();
    } catch (error) {
      // Reject the promise if an error occurs
      reject(error);
    }
  });
};

export const getSessionId = () => {
  let sessionId = localStorage.getItem("guestSessionId");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem("guestSessionId", sessionId);
  }
  return sessionId;
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getRefreshToken = () => {
  return localStorage.getItem(TOKEN_KEY_REFRESH);
};

export const userLogOut = async () => {
  console.log("remove token....");
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY_REFRESH);
  return true;
};

export const isLogin = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  console.warn("token", token);
  const decodedJwt = parseJwt(token);
  console.info("decodedJwt", decodedJwt && decodedJwt.exp * 1000 < Date.now());
  const expiered = decodedJwt && decodedJwt.exp * 1000 < Date.now();

  if (token && !expiered) {
    let decode = decodeToken(token);
    console.log("access main console : welcome");
    return true;
  } else {
    console.error("User cant be access main console : token not found");
    return false;
  }
};

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const userDetails = () => {
  console.info("get  user details....");
  const token = localStorage.getItem(TOKEN_KEY);
  console.log("token", decodeToken(token));
  if (token) {
    //  console.log(decodeToken(token));
    const decodedJwt = parseJwt(token);
    // console.info("decodedJwt", decodedJwt &&decodedJwt.exp * 1000 < Date.now());
    if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
      return false;
    }
    return decodeToken(token);
  } else {
    console.info("user  details not found....");
    return false;
  }
};
